import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';

import { ConsumerMoneyProvider } from '../../providers/consumer-money-handler';

import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';

import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';	

import { ConsumerAddMoneyPage } from '../../pages/consumer-add-money/consumer-add-money';
import { ConsumerMoneyAddDevicePage } from '../../pages/consumer-money-add-device/consumer-money-add-device';
import { ConsumerProductPaymentManagerPage } from '../../pages/consumer-product-payment-manager/consumer-product-payment-manager';


import { BaseListPage } from '../../providers/base-list-page';
import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-consumer-business-detail',
  templateUrl: 'consumer-business-detail.html',
})
export class ConsumerBusinessDetailPage {
	qrCodeUrl: any;

	businessId: any;
	filePath: any;
	businessFilePath: any;

	isPinned: any = false;

	requiresReload: boolean = false;
	isLoading: boolean = false;
	isRefreshing: boolean = false;
	filter: string = "orders";

	map: any;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public mainHandler: ConsumerBusinessHandlerProvider,
		public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 	
		
		public pushNotificationHandlerProvider: PushNotificationHandlerProvider,
		private elRef: ElementRef,
		public globals: Globals,
		public platform: Platform,
	) {
		this.requiresReload = navParams.get('requiresReload');	
		this.filePath = this.globals.fileUrl;
	
		this.mainHandler.business = navParams.get('business');	

		this.qrCodeUrl = this.globals.dataUrl + "qrcode/" + this.mainHandler.business.Id + '-' + this.mainHandler.business.ConsumerId + '-USER';		   

		this.businessFilePath = this.globals.fileUrl + this.mainHandler.business.ImagePath;

		this.loadBusinessInfo();
	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.fetchBusiness(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	loadBusinessInfo(){
		this.isPinned = this.mainHandler.business.IsPinned;
	}

	fetchBusiness(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.mainHandler.getBusinessMoneyById(
		{
			id: this.mainHandler.business.Id,
			size: 1,
			cb: (business)=>{
				this.loadBusinessInfo()

				if(typeof cb == "function")
					cb()	

				this.isLoading = false;
			}
		})
	}

	pin(){	
		if(this.isPinned){
			this.isPinned = false;	
		}else{
			this.isPinned = true;	
		}  		 

		var params = {
			businessId: this.mainHandler.business.Id,
			pinned: this.isPinned
		}

		this.mainHandler.pinBusiness(params, ()=>{
			if(this.isPinned){
				this.pushNotificationHandlerProvider.subscribeToBusiness(this.mainHandler.business.Id)	
			}else{
				this.pushNotificationHandlerProvider.unsubscribeToBusiness(this.mainHandler.business.Id)	
			}			
		})
	}

	gotoAddMoney($ev, business){
		this.navCtrl.push(ConsumerAddMoneyPage, {
		  business: this.mainHandler.business
		});
	}

	gotoAddDevice($ev, business){
		this.navCtrl.push(ConsumerMoneyAddDevicePage, {
		  business: this.mainHandler.business
		});
	}	

	gotoPlaceOrder($ev, business){
		this.navCtrl.push(ConsumerProductPaymentManagerPage, {
		  business: this.mainHandler.business
		});
	}				
}



// WEBPACK FOOTER //
// ./src/pages/consumer-business-detail/consumer-business-detail.ts